import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ProviderResponse } from "../../shared/models/provider.model";
import { ProviderService } from "../../shared/services/provider.service";

@Injectable({
    providedIn: 'root',
})
export class GetProvidersResolver implements Resolve<ProviderResponse[]> {

    constructor(
        private providerService: ProviderService,
    ) { }

    resolve(): Observable<ProviderResponse[]> {
        return this.providerService.getAll();
    }
}
